import { observable, makeObservable } from 'mobx';
import Metric from './Metric';

class MetricViewModel {
  data;

  editingValue;
  isEditing = false;

  constructor(data) {
    makeObservable(this, {
      data: observable,
      editingValue: observable,
      isEditing: observable
    });

    this.data = new Metric(data);
    this.editingValue = this.data.currentValue;
  }
}

export default MetricViewModel;
